import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useEffect } from "react";

const Agb = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 mt-16 sm:mt-20 max-w-4xl">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 sm:mb-8 text-foreground">
          Allgemeine Geschäfts- und Nutzungsbedingungen
        </h1>
        <p className="text-sm text-muted-foreground mb-8">Stand: August 2026</p>

        <div className="prose prose-sm sm:prose-base lg:prose-lg max-w-none text-foreground/90 space-y-4 sm:space-y-6">
          <section>
            <p>
              Allgemeine Geschäfts- und Nutzungsbedingungen der Scholz & Scholz Recruitment UG (haftungsbeschränkt), Römerstraße 6, 21680 Stade, für die Nutzung des Internetangebotes unter www.scholz-interim.de.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 1 Geltungsbereich und Gegenstand dieser Nutzungsbedingungen</h2>
            <p>
              (1) Die nachfolgenden Allgemeinen Geschäfts- und Nutzungsbedingungen regeln die Nutzung der von der Scholz & Scholz Recruitment UG (haftungsbeschränkt), nachfolgend auch „Scholz Interim", „Betreiberin", „Anbieterin" oder „wir" genannt, unter der Internetadresse www.scholz-interim.de sowie gegebenenfalls unter zugehörigen Unterseiten, Subdomains und sonstigen unmittelbar hiermit verbundenen digitalen Angeboten bereitgestellten Internetpräsenz.
            </p>
            <p>
              (2) Diese Nutzungsbedingungen gelten für sämtliche Besucher, Nutzer, Bewerber, Kandidaten, Interessenten, Unternehmen, Geschäftspartner und sonstigen Personen, die auf die Website oder deren Inhalte zugreifen.
            </p>
            <p>
              (3) Gegenstand dieser Nutzungsbedingungen sind ausschließlich die rechtlichen Rahmenbedingungen der Nutzung der Website und der dort bereitgestellten Inhalte, Informationen, Funktionen und Kontaktmöglichkeiten.
            </p>
            <p>
              (4) Diese Nutzungsbedingungen regeln ausdrücklich nicht die Bedingungen einer konkreten Personalvermittlung, Personalberatung, Pächtersuche, Management-, Beratungs-, Coaching-, Trainings- oder sonstigen Dienstleistung. Für derartige Leistungen gelten ausschließlich die im jeweiligen Einzelfall zwischen der Scholz & Scholz Recruitment UG (haftungsbeschränkt) und dem jeweiligen Auftraggeber oder Vertragspartner getroffenen Vereinbarungen.
            </p>
            <p>
              (5) Soweit zwischen diesen Nutzungsbedingungen und einer individuell mit einem Kunden, Auftraggeber, Kandidaten, Bewerber oder sonstigen Vertragspartner geschlossenen Vereinbarung ein Widerspruch bestehen sollte, geht die individuelle Vereinbarung im Rahmen ihres jeweiligen Regelungsgegenstandes vor.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 2 Anbieterin der Website</h2>
            <p>
              (1) Anbieterin und Betreiberin der Website ist die Scholz & Scholz Recruitment UG (haftungsbeschränkt), Römerstraße 6, 21680 Stade.
            </p>
            <p>
              (2) Ergänzende Angaben zur Anbieterin, zu den vertretungsberechtigten Personen, Registerangaben, Kontaktmöglichkeiten sowie sonstige gesetzlich vorgeschriebene Pflichtinformationen sind dem Impressum dieser Website zu entnehmen.
            </p>
            <p>
              (3) Die gesetzlich vorgeschriebenen Anbieterinformationen werden entsprechend den jeweils geltenden Vorschriften, insbesondere den für digitale Dienste bestehenden Informationspflichten, bereitgehalten.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 3 Zweck und Charakter des Internetangebotes</h2>
            <p>
              (1) Die Website dient insbesondere der Darstellung der Scholz & Scholz Recruitment UG (haftungsbeschränkt), ihrer Tätigkeitsfelder, ihrer fachlichen Schwerpunkte sowie der Information über Dienstleistungen, Projekte, Stellenangebote, Karrierechancen und sonstige Themen aus den Bereichen Hotellerie, Gastronomie, Personalberatung, Recruiting, Executive Search, Interim Management, Verpachtung, Management und Beratung.
            </p>
            <p>
              (2) Darüber hinaus ermöglicht die Website die Kontaktaufnahme mit Scholz Interim und kann Möglichkeiten zur Übermittlung von Bewerbungen, Lebensläufen, Anfragen oder sonstigen Unterlagen zur Verfügung stellen.
            </p>
            <p>
              (3) Sämtliche auf dieser Website veröffentlichten Informationen dienen grundsätzlich der allgemeinen Information und geschäftlichen Kontaktanbahnung. Sofern nicht im Einzelfall ausdrücklich und eindeutig anders bezeichnet, stellen Inhalte der Website kein rechtlich bindendes Angebot im Sinne des § 145 BGB dar.
            </p>
            <p>
              (4) Insbesondere begründen die Darstellung von Dienstleistungen, die Veröffentlichung eines Stellenangebotes, einer Vakanz, eines Projektes, einer Unternehmensbeschreibung oder einer sonstigen geschäftlichen Möglichkeit keinen Anspruch auf Abschluss eines Vertrages oder Durchführung einer bestimmten Leistung.
            </p>
            <p>
              (5) Ebenso entsteht durch den bloßen Aufruf oder die Nutzung der Website kein Personalvermittlungs-, Beratungs-, Dienstleistungs-, Arbeits-, Geschäftsbesorgungs-, Makler- oder sonstiges Vertragsverhältnis zwischen dem Nutzer und der Scholz & Scholz Recruitment UG (haftungsbeschränkt).
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 4 Allgemeine Voraussetzungen für die Nutzung</h2>
            <p>
              (1) Die Nutzung der öffentlich zugänglichen Bereiche dieser Website ist grundsätzlich ohne vorherige Registrierung zulässig.
            </p>
            <p>
              (2) Jeder Nutzer ist verpflichtet, bei der Nutzung der Website die geltenden gesetzlichen Vorschriften, Rechte Dritter sowie die Bestimmungen dieser Nutzungsbedingungen zu beachten.
            </p>
            <p>
              (3) Die Website darf ausschließlich in einer Weise genutzt werden, die ihrem bestimmungsgemäßen Zweck entspricht und weder die Funktionsfähigkeit, Sicherheit, Integrität noch die Verfügbarkeit der Website oder der hierfür eingesetzten technischen Systeme beeinträchtigt.
            </p>
            <p>
              (4) Untersagt sind insbesondere Handlungen, die geeignet sind,
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>technische Systeme oder Sicherheitsmechanismen der Website zu umgehen, zu manipulieren oder zu beeinträchtigen,</li>
              <li>unberechtigten Zugriff auf nicht öffentlich zugängliche Bereiche, Daten oder Systeme zu ermöglichen,</li>
              <li>Schadsoftware, Viren, Trojaner, automatisierte Angriffsskripte oder vergleichbare schädliche Technologien einzusetzen,</li>
              <li>die Website mit einer unangemessen hohen Zahl automatisierter Anfragen zu belasten,</li>
              <li>Daten oder Inhalte unbefugt zu verändern, zu löschen, zu vervielfältigen oder weiterzugeben,</li>
              <li>die Herkunft oder Authentizität von Informationen zu verschleiern oder</li>
              <li>Rechte der Scholz & Scholz Recruitment UG (haftungsbeschränkt), ihrer Geschäftspartner, Kunden, Bewerber, Kandidaten oder sonstiger Dritter zu verletzen.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 5 Urheberrechtlicher Schutz der Website und ihrer Inhalte</h2>
            <p>
              (1) Die auf dieser Website veröffentlichten Inhalte und Werke unterliegen, soweit die gesetzlichen Voraussetzungen hierfür vorliegen, dem deutschen Urheberrecht sowie gegebenenfalls weiteren gesetzlichen Schutzrechten. Hierzu gehören insbesondere Sprachwerke, Lichtbildwerke, Fotografien, grafische Darstellungen und sonstige geschützte Werke im Sinne der §§ 2 ff. UrhG.
            </p>
            <p>
              (2) Der urheberrechtliche Schutz umfasst insbesondere die dem Rechtsinhaber zustehenden ausschließlichen Verwertungsrechte gemäß §§ 15 ff. UrhG, insbesondere das Recht zur Vervielfältigung, Verbreitung und öffentlichen Zugänglichmachung.
            </p>
            <p>
              (3) Schutzfähig beziehungsweise durch gesetzliche oder vertragliche Rechte geschützt können insbesondere sein: Texte und redaktionelle Beiträge, Unternehmensbeschreibungen, Leistungsbeschreibungen, Stellenanzeigen, Stellen- und Anforderungsprofile, Projektbeschreibungen, Überschriften und redaktionelle Zusammenstellungen, Fotografien, Mitarbeiter- und Unternehmensbilder, Grafiken und Illustrationen, Logos, Videos und Animationen, Präsentationen, Tabellen und Darstellungen, Gestaltungselemente, Seitenstrukturen, Auswahl und Zusammenstellung von Inhalten, Datenbanken und Datensammlungen sowie sonstige eigenschöpferische Inhalte und Medien.
            </p>
            <p>
              (4) Soweit einzelne auf dieser Website verwendete Inhalte nicht im Eigentum der Scholz & Scholz Recruitment UG (haftungsbeschränkt) stehen, bestehen entsprechende Nutzungsrechte oder Rechte Dritter. Die Rechte dieser Dritten bleiben uneingeschränkt bestehen.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 6 Verbot der unbefugten Vervielfältigung, Verbreitung und Veröffentlichung</h2>
            <p>
              (1) Die Vervielfältigung, Bearbeitung, Umgestaltung, Übersetzung, Verbreitung, Speicherung, Archivierung, öffentliche Wiedergabe oder öffentliche Zugänglichmachung von Inhalten dieser Website ist außerhalb der gesetzlichen Schranken des Urheberrechts ohne vorherige Zustimmung des jeweiligen Rechteinhabers nicht gestattet.
            </p>
            <p>
              (2) Dies gilt unabhängig davon, ob Inhalte vollständig oder nur in wesentlichen Teilen übernommen werden.
            </p>
            <p>
              (3) Insbesondere ist es ohne vorherige ausdrückliche Zustimmung nicht gestattet,
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>Texte dieser Website auf anderen Internetseiten zu veröffentlichen,</li>
              <li>Stellenanzeigen oder Stellenbeschreibungen vollständig oder in wesentlichen Teilen zu kopieren,</li>
              <li>Projektbeschreibungen oder sonstige redaktionelle Inhalte zu übernehmen,</li>
              <li>Inhalte für eigene geschäftliche Werbe-, Recruiting-, Vermittlungs- oder Marketingzwecke zu verwenden,</li>
              <li>Inhalte in sozialen Netzwerken, Datenbanken, Internetportalen oder anderen digitalen Diensten als eigene Inhalte zu veröffentlichen,</li>
              <li>Inhalte durch geringfügige sprachliche, grafische oder strukturelle Veränderungen zu bearbeiten und anschließend als eigene Inhalte auszugeben,</li>
              <li>Fotografien, Grafiken, Logos, Layoutbestandteile oder sonstige Gestaltungselemente ohne entsprechende Berechtigung zu übernehmen oder</li>
              <li>Inhalte der Website in einer Weise zu verwenden, die den unzutreffenden Eindruck einer geschäftlichen, organisatorischen oder sonstigen Verbindung mit Scholz Interim entstehen lässt.</li>
            </ul>
            <p>
              (4) Die gesetzlichen Schranken des Urheberrechts bleiben unberührt.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 7 Besonderer Schutz von Stellenanzeigen und Stellenbeschreibungen</h2>
            <p>
              (1) Die von Scholz Interim veröffentlichten Stellenanzeigen, Positionsbeschreibungen und Projektinformationen werden regelmäßig individuell erstellt, bearbeitet, redaktionell aufbereitet und auf den jeweiligen Suchauftrag beziehungsweise die jeweilige Position zugeschnitten.
            </p>
            <p>
              (2) Eine gewerbliche oder geschäftsmäßige Übernahme oder Weiterverwendung solcher Inhalte durch Dritte ist ohne entsprechende Berechtigung nicht gestattet.
            </p>
            <p>
              (3) Insbesondere untersagt ist – soweit keine gesetzliche Berechtigung besteht – die Verwendung entsprechender Inhalte durch andere Personalvermittlungen, Personalberatungen, Headhunter, Recruitingunternehmen, Stellenbörsen, Job-Aggregatoren, Datenbanken, Karriereplattformen, Vermittlungsplattformen oder sonstige gewerblich handelnde Dritte, wenn eine entsprechende Nutzung ohne Zustimmung der Scholz & Scholz Recruitment UG (haftungsbeschränkt) erfolgt.
            </p>
            <p>
              (4) Dies gilt insbesondere auch dann, wenn eine Stellenanzeige anonymisiert oder der jeweilige Auftraggeber, Arbeitgeber oder Betrieb innerhalb der Veröffentlichung nicht ausdrücklich benannt wird.
            </p>
            <p>
              (5) Eine Veränderung einzelner Formulierungen oder eine lediglich teilweise Übernahme beseitigt bestehende Urheber-, Datenbank-, Wettbewerbs- oder sonstige Schutzrechte nicht.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 8 Automatisierte Zugriffe, Scraping und Datenerhebung</h2>
            <p>
              (1) Eine systematische automatisierte Auswertung, Erfassung oder Speicherung der auf dieser Website bereitgestellten Inhalte ist vorbehaltlich gesetzlich zwingend zulässiger Nutzungen nicht gestattet.
            </p>
            <p>
              (2) Dies betrifft insbesondere den Einsatz von Webcrawlern, Scraping-Software, Bots, automatisierten Agenten, automatisierten Downloadprogrammen, Parsern, Indexierungsprogrammen außerhalb der üblichen Suchmaschinenindexierung, Datenextraktionssystemen oder technisch vergleichbaren Verfahren, soweit hiermit Inhalte der Website systematisch erfasst, vervielfältigt, ausgewertet oder für eigene geschäftliche Zwecke nutzbar gemacht werden.
            </p>
            <p>
              (3) Die technisch notwendige oder übliche Indexierung durch allgemein zugängliche Suchmaschinen bleibt hiervon unberührt, soweit sie im Rahmen der von Scholz Interim gesetzten technischen Zugriffsmöglichkeiten und Vorgaben erfolgt.
            </p>
            <p>
              (4) Die Scholz & Scholz Recruitment UG (haftungsbeschränkt) behält sich vor, automatisierte Zugriffe technisch zu beschränken oder zu unterbinden, soweit dies rechtlich zulässig ist.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 9 Text und Data Mining sowie Nutzung für Systeme künstlicher Intelligenz</h2>
            <p>
              (1) Soweit der Scholz & Scholz Recruitment UG (haftungsbeschränkt) die hierfür erforderlichen Rechte zustehen, behält sie sich ausdrücklich die Nutzung ihrer online zugänglichen urheberrechtlich geschützten Werke für Zwecke des Text und Data Mining gemäß § 44b Abs. 3 UrhG vor.
            </p>
            <p>
              (2) Dieser Vorbehalt betrifft insbesondere die automatisierte Analyse, Extraktion oder Verarbeitung von Texten, Stellenanzeigen, redaktionellen Beiträgen, Datenbeständen, Bildern und sonstigen geschützten Inhalten dieser Website.
            </p>
            <p>
              (3) Soweit rechtlich zulässig, ist insbesondere eine systematische Übernahme von geschützten Website-Inhalten zur Erstellung kommerzieller Datensätze, zum Aufbau von Recruiting- oder Stellenangebotsdatenbanken, zur automatisierten Reproduktion vergleichbarer Inhalte, zur Erstellung konkurrierender Angebote oder für das Training, die Weiterentwicklung oder sonstige kommerzielle Nutzung von Systemen künstlicher Intelligenz ohne vorherige Zustimmung nicht gestattet.
            </p>
            <p>
              (4) Gesetzlich zwingend zulässige Nutzungen, insbesondere solche, die nicht wirksam ausgeschlossen werden können, bleiben unberührt.
            </p>
            <p>
              (5) Soweit für einen wirksamen Nutzungsvorbehalt eine maschinenlesbare Erklärung erforderlich ist, gilt zusätzlich die jeweils von Scholz Interim technisch implementierte maschinenlesbare Erklärung.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 10 Datenbanken und Zusammenstellungen</h2>
            <p>
              (1) Soweit die Website Datenbanken oder systematisch beziehungsweise methodisch angeordnete Sammlungen von Inhalten enthält, bleiben etwaige Rechte nach den §§ 4, 87a ff. UrhG unberührt.
            </p>
            <p>
              (2) Die wiederholte oder systematische Entnahme beziehungsweise Weiterverwendung von wesentlichen oder unwesentlichen Teilen entsprechender Datenbestände ist nicht gestattet, soweit dadurch Rechte der Scholz & Scholz Recruitment UG (haftungsbeschränkt) oder sonstiger Rechteinhaber verletzt werden.
            </p>
            <p>
              (3) Dies gilt insbesondere für systematische Sammlungen von Stellenangeboten, Projektdaten oder sonstigen strukturierten Informationen.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 11 Geschäftsbezeichnungen, Marken, Logos und Kennzeichen</h2>
            <p>
              (1) Auf der Website verwendete Unternehmenskennzeichen, Geschäftsbezeichnungen, Marken, Logos, Namen und sonstige Kennzeichen können markenrechtlich, namensrechtlich oder auf sonstige Weise geschützt sein.
            </p>
            <p>
              (2) Aus der bloßen Abrufbarkeit dieser Kennzeichen auf der Website folgt keinerlei Einräumung eines Nutzungsrechts zugunsten des jeweiligen Nutzers.
            </p>
            <p>
              (3) Die Verwendung von Kennzeichen der Scholz & Scholz Recruitment UG (haftungsbeschränkt) für eigene geschäftliche Zwecke, insbesondere zur Werbung, Kundenakquise, Kennzeichnung eigener Leistungen oder zur Erzeugung des Eindrucks einer geschäftlichen Kooperation, bedarf einer entsprechenden Berechtigung.
            </p>
            <p>
              (4) Rechte Dritter an auf dieser Website genannten Marken, Produktbezeichnungen, Unternehmensnamen oder sonstigen Kennzeichen bleiben unberührt.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 12 Deep Links, Framing und Einbindung von Website-Inhalten</h2>
            <p>
              (1) Die Verlinkung auf öffentlich zugängliche Seiten dieser Website ist grundsätzlich zulässig, soweit die Verlinkung in einer rechtlich zulässigen Weise erfolgt und insbesondere kein irreführender Eindruck hinsichtlich der Herkunft der Inhalte oder einer geschäftlichen Zusammenarbeit entsteht.
            </p>
            <p>
              (2) Nicht gestattet ist insbesondere eine technische oder gestalterische Einbindung von Website-Inhalten in fremde Internetangebote in einer Weise, bei der für den Nutzer nicht eindeutig erkennbar ist, dass die jeweiligen Inhalte von Scholz Interim stammen.
            </p>
            <p>
              (3) Dies betrifft insbesondere unzulässiges Framing, Inline-Linking oder sonstige technische Gestaltungen, soweit hierdurch Urheberrechte, Kennzeichenrechte, wettbewerbsrechtliche Vorschriften oder sonstige Rechte verletzt werden.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 13 Bewerbungen und Übermittlung von Unterlagen</h2>
            <p>
              (1) Soweit über diese Website eine Bewerbung, ein Lebenslauf, Zeugnisse, Referenzen oder sonstige Unterlagen an Scholz Interim übermittelt werden können, dient diese Möglichkeit der Kontaktaufnahme und gegebenenfalls der Prüfung einer möglichen Zusammenarbeit oder Vermittlung.
            </p>
            <p>
              (2) Mit der Übermittlung von Bewerbungsunterlagen entsteht kein Anspruch auf eine Vermittlung, eine Vorstellung bei einem bestimmten Unternehmen, die Aufnahme in einen Kandidatenpool, die Teilnahme an einem bestimmten Auswahlverfahren, die Durchführung eines persönlichen Gespräches, eine bestimmte Bearbeitungsdauer oder den Abschluss eines Arbeits-, Dienstleistungs- oder sonstigen Vertrages.
            </p>
            <p>
              (3) Scholz Interim ist berechtigt, Anfragen oder Bewerbungen nach pflichtgemäßem Ermessen zu prüfen und zu entscheiden, ob und in welcher Form eine weitere Kontaktaufnahme oder Zusammenarbeit erfolgt.
            </p>
            <p>
              (4) Die Verarbeitung personenbezogener Daten richtet sich nach den geltenden datenschutzrechtlichen Vorschriften und den ergänzenden Informationen in der Datenschutzerklärung der Website.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 14 Kontaktanfragen von Unternehmen und sonstigen Interessenten</h2>
            <p>
              (1) Unternehmen und sonstige Interessenten können über die auf der Website bereitgestellten Kontaktmöglichkeiten Anfragen an Scholz Interim richten.
            </p>
            <p>
              (2) Eine solche Kontaktaufnahme stellt grundsätzlich lediglich die Anbahnung einer möglichen Geschäftsbeziehung dar.
            </p>
            <p>
              (3) Durch die Übermittlung einer Anfrage kommt – sofern nicht ausdrücklich etwas anderes vereinbart wird – noch kein entgeltlicher Vertrag zustande.
            </p>
            <p>
              (4) Art, Umfang, Vergütung und sonstige Bedingungen einer etwaigen späteren Zusammenarbeit werden unabhängig von diesen Website-Nutzungsbedingungen individuell vereinbart.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 15 Richtigkeit, Vollständigkeit und Aktualität der Website-Inhalte</h2>
            <p>
              (1) Scholz Interim erstellt und pflegt die Inhalte dieser Website mit der im geschäftlichen Verkehr angemessenen Sorgfalt.
            </p>
            <p>
              (2) Gleichwohl kann nicht gewährleistet werden, dass sämtliche Informationen jederzeit vollständig, fehlerfrei und auf dem neuesten Stand sind.
            </p>
            <p>
              (3) Insbesondere können sich geschäftliche, personelle, organisatorische oder sonstige tatsächliche Umstände kurzfristig verändern, ohne dass die entsprechende Änderung bereits auf der Website nachvollzogen wurde.
            </p>
            <p>
              (4) Dies gilt insbesondere für Angaben über offene Positionen, laufende Suchprojekte, Eintrittstermine, Einsatzorte, Unternehmensstrukturen, Ansprechpartner, Tätigkeitsbereiche, verfügbare Dienstleistungen, Termine oder sonstige veränderliche Informationen.
            </p>
            <p>
              (5) Stellenangebote können beispielsweise bereits besetzt, zurückgezogen, verändert oder vorübergehend ausgesetzt worden sein, obwohl sie technisch noch abrufbar sind.
            </p>
            <p>
              (6) Maßgeblich für eine konkrete geschäftliche Zusammenarbeit oder ein konkretes Bewerbungs- oder Auswahlverfahren sind daher stets die individuell kommunizierten Informationen und Vereinbarungen.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 16 Keine individuelle Rechts-, Steuer- oder sonstige Fachberatung durch Website-Inhalte</h2>
            <p>
              (1) Allgemeine Informationen, Artikel, Beiträge, Erläuterungen, Einschätzungen oder sonstige Inhalte auf dieser Website dienen ausschließlich allgemeinen Informationszwecken.
            </p>
            <p>
              (2) Sie ersetzen keine auf den jeweiligen Einzelfall abgestimmte rechtliche, steuerrechtliche, sozialversicherungsrechtliche oder sonstige fachliche Beratung.
            </p>
            <p>
              (3) Soweit auf der Website Themen mit rechtlicher, steuerlicher, arbeitsrechtlicher oder wirtschaftlicher Relevanz behandelt werden, sind diese Angaben lediglich als allgemeine Information zu verstehen, sofern nicht ausdrücklich eine individuelle Beratungsleistung vereinbart worden ist.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 17 Keine Gewähr für einen bestimmten Erfolg</h2>
            <p>
              (1) Aus der Darstellung von Erfahrungen, Referenzen, Projekten, Tätigkeitsgebieten oder sonstigen Ergebnissen auf der Website lässt sich kein Anspruch darauf ableiten, dass in zukünftigen Fällen gleiche oder vergleichbare Ergebnisse erzielt werden.
            </p>
            <p>
              (2) Vergangene Projekte, Referenzen oder dargestellte Beispiele dienen lediglich der Beschreibung der Tätigkeit und Erfahrung von Scholz Interim.
            </p>
            <p>
              (3) Jeder Auftrag, jedes Unternehmen, jede Position und jede Bewerbersituation unterliegt individuellen Umständen und Rahmenbedingungen.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 18 Verfügbarkeit und technische Funktionsfähigkeit der Website</h2>
            <p>
              (1) Scholz Interim bemüht sich um eine möglichst störungsfreie und dauerhafte Verfügbarkeit der Website.
            </p>
            <p>
              (2) Ein Anspruch auf eine jederzeitige, ununterbrochene und fehlerfreie Erreichbarkeit der Website oder einzelner Funktionen besteht jedoch nicht.
            </p>
            <p>
              (3) Insbesondere können technische Wartungsarbeiten, Sicherheitsmaßnahmen, Systemupdates, technische Störungen, Ausfälle von Telekommunikationsnetzen oder Leistungen externer Dienstleister zu einer vorübergehenden Einschränkung der Verfügbarkeit führen.
            </p>
            <p>
              (4) Scholz Interim ist berechtigt, einzelne Inhalte, Funktionen, Seitenbereiche oder die gesamte Website jederzeit zu verändern, zu ergänzen, einzuschränken oder vorübergehend beziehungsweise dauerhaft einzustellen, soweit keine zwingenden gesetzlichen Verpflichtungen entgegenstehen.
            </p>
            <p>
              (5) Aus einer Änderung, Einschränkung oder Einstellung einzelner Websitefunktionen entstehen dem Nutzer grundsätzlich keine Ansprüche, sofern nicht im konkreten Einzelfall zwingende gesetzliche Vorschriften etwas anderes bestimmen.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 19 Externe Links und Inhalte Dritter</h2>
            <p>
              (1) Diese Website kann Verlinkungen zu externen Internetseiten und sonstigen digitalen Angeboten Dritter enthalten.
            </p>
            <p>
              (2) Bei der erstmaligen Verlinkung werden externe Inhalte im zumutbaren Umfang darauf überprüft, ob erkennbare Rechtsverstöße bestehen.
            </p>
            <p>
              (3) Scholz Interim hat jedoch keinen fortlaufenden Einfluss auf Gestaltung, Inhalt, Sicherheit, Aktualität oder Verfügbarkeit externer Internetangebote.
            </p>
            <p>
              (4) Für Inhalte verlinkter externer Seiten ist grundsätzlich der jeweilige Anbieter beziehungsweise Betreiber verantwortlich.
            </p>
            <p>
              (5) Eine permanente inhaltliche Kontrolle verlinkter Seiten ohne konkrete Anhaltspunkte für eine Rechtsverletzung ist nicht geschuldet.
            </p>
            <p>
              (6) Werden Scholz Interim konkrete Rechtsverletzungen auf einer verlinkten Seite bekannt, wird die entsprechende Verlinkung im Rahmen der rechtlichen und tatsächlichen Möglichkeiten überprüft und gegebenenfalls entfernt.
            </p>
            <p>
              (7) Eine Verlinkung bedeutet insbesondere nicht automatisch, dass Scholz Interim sich sämtliche dort abrufbaren Inhalte zu eigen macht oder eine geschäftliche Empfehlung für sämtliche Leistungen des verlinkten Anbieters ausspricht.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 20 Haftung für die Nutzung der Website</h2>
            <p>
              (1) Die Scholz & Scholz Recruitment UG (haftungsbeschränkt) haftet nach den gesetzlichen Vorschriften
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>für vorsätzlich oder grob fahrlässig verursachte Schäden,</li>
              <li>für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit sowie</li>
              <li>in sonstigen Fällen, in denen eine Haftung gesetzlich zwingend vorgeschrieben ist.</li>
            </ul>
            <p>
              (2) Bei leicht fahrlässiger Verletzung einer wesentlichen Verpflichtung ist die Haftung auf den nach Art der Nutzung vorhersehbaren und typischerweise eintretenden Schaden begrenzt, soweit eine solche Haftungsbegrenzung gesetzlich zulässig ist.
            </p>
            <p>
              (3) Wesentliche Verpflichtungen im Sinne des vorstehenden Absatzes sind solche, deren Erfüllung eine ordnungsgemäße Nutzung des jeweils angebotenen Dienstes überhaupt erst ermöglicht und auf deren Einhaltung ein Nutzer regelmäßig vertrauen darf.
            </p>
            <p>
              (4) Im Übrigen ist die Haftung für leicht fahrlässig verursachte Schäden ausgeschlossen, soweit dies gesetzlich zulässig ist.
            </p>
            <p>
              (5) Zwingende gesetzliche Haftungsvorschriften bleiben von den vorstehenden Regelungen unberührt.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 21 Haftung für vom Nutzer übermittelte Inhalte</h2>
            <p>
              (1) Nutzer, die über die Website oder die dort angegebenen Kommunikationswege Informationen, Texte, Bilder, Bewerbungsunterlagen, Zeugnisse, Referenzen oder sonstige Inhalte übermitteln, sind dafür verantwortlich, dass sie zur Übermittlung dieser Inhalte berechtigt sind.
            </p>
            <p>
              (2) Der Nutzer darf insbesondere keine Inhalte übermitteln, durch deren Übermittlung oder Verarbeitung Rechte Dritter verletzt werden.
            </p>
            <p>
              (3) Dies betrifft insbesondere Urheberrechte, Persönlichkeitsrechte, Datenschutzrechte, Geschäftsgeheimnisse und sonstige Schutzrechte.
            </p>
            <p>
              (4) Die gesetzlichen Verantwortlichkeiten der Parteien bleiben hiervon unberührt.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 22 Datenschutz</h2>
            <p>
              (1) Der Schutz personenbezogener Daten hat für Scholz Interim einen hohen Stellenwert.
            </p>
            <p>
              (2) Personenbezogene Daten werden ausschließlich unter Beachtung der jeweils geltenden gesetzlichen Datenschutzbestimmungen verarbeitet.
            </p>
            <p>
              (3) Informationen über Art, Umfang, Zwecke und Rechtsgrundlagen der Verarbeitung personenbezogener Daten sowie über die Rechte betroffener Personen enthält die gesonderte Datenschutzerklärung dieser Website.
            </p>
            <p>
              (4) Diese Nutzungsbedingungen ersetzen die Datenschutzerklärung nicht.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 23 Schutz vertraulicher und nicht öffentlich bestimmter Informationen</h2>
            <p>
              (1) Informationen, die einem Nutzer lediglich aufgrund einer individuellen Kommunikation mit Scholz Interim zugänglich gemacht werden und nach ihrer Art erkennbar nicht für die Öffentlichkeit bestimmt sind, dürfen nicht ohne Berechtigung öffentlich verbreitet oder für sachfremde Zwecke verwendet werden.
            </p>
            <p>
              (2) Dies gilt insbesondere für vertrauliche Informationen über Kunden, Kandidaten, Bewerber, Unternehmen, konkrete Suchprojekte, Personalentscheidungen, Unternehmensstrukturen, Vergütungen, wirtschaftliche Verhältnisse oder interne Geschäftsabläufe.
            </p>
            <p>
              (3) Gesetzliche Offenlegungsrechte und Offenlegungspflichten bleiben unberührt.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 24 Maßnahmen bei missbräuchlicher Nutzung</h2>
            <p>
              (1) Scholz Interim behält sich vor, im Falle einer rechtswidrigen oder missbräuchlichen Nutzung der Website im Rahmen der gesetzlichen Möglichkeiten geeignete technische oder rechtliche Maßnahmen zu ergreifen.
            </p>
            <p>
              (2) Dies kann insbesondere die Sperrung automatisierter Zugriffe, die Beschränkung einzelner Zugriffsmöglichkeiten oder die Geltendmachung gesetzlich bestehender Unterlassungs-, Auskunfts-, Beseitigungs- oder Schadensersatzansprüche umfassen.
            </p>
            <p>
              (3) Weitergehende gesetzliche Rechte bleiben unberührt.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 25 Keine Einräumung weitergehender Rechte</h2>
            <p>
              (1) Die Nutzung der Website führt, soweit nicht ausdrücklich etwas anderes vereinbart wird, zu keiner Übertragung oder Einräumung von Urheber-, Marken-, Kennzeichen-, Datenbank-, Persönlichkeits- oder sonstigen Schutz- oder Nutzungsrechten.
            </p>
            <p>
              (2) Insbesondere folgt aus der bloßen Möglichkeit, Inhalte auf einem Endgerät anzuzeigen, technisch zwischenzuspeichern oder im Rahmen der normalen Browsernutzung aufzurufen, kein darüber hinausgehendes Recht zur wirtschaftlichen Nutzung dieser Inhalte.
            </p>
            <p>
              (3) Gesetzlich zulässige Nutzungshandlungen bleiben unberührt.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 26 Änderungen und Weiterentwicklung des Internetangebotes</h2>
            <p>
              (1) Scholz Interim behält sich vor, die Gestaltung, Struktur, Funktionen und Inhalte dieser Website jederzeit weiterzuentwickeln und an technische, gesetzliche, wirtschaftliche oder unternehmerische Veränderungen anzupassen.
            </p>
            <p>
              (2) Hierzu können insbesondere Änderungen an Navigationsstrukturen, Formularen, Bewerbungsfunktionen, Stellenangeboten, Leistungsbeschreibungen, technischen Schnittstellen, Sicherheitsmaßnahmen oder sonstigen Websitebestandteilen gehören.
            </p>
            <p>
              (3) Ein Anspruch des Nutzers auf Beibehaltung eines bestimmten technischen oder gestalterischen Zustandes der Website besteht nicht.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 27 Änderungen dieser Geschäfts- und Nutzungsbedingungen</h2>
            <p>
              (1) Scholz Interim behält sich vor, diese Allgemeinen Geschäfts- und Nutzungsbedingungen unter Berücksichtigung der gesetzlichen Vorgaben zu ändern, insbesondere wenn dies aufgrund gesetzlicher Änderungen, neuer Rechtsprechung, technischer Entwicklungen, Änderungen des Internetangebotes oder einer Erweiterung oder Veränderung der angebotenen Websitefunktionen erforderlich oder sachgerecht erscheint.
            </p>
            <p>
              (2) Für die allgemeine Nutzung der Website ist grundsätzlich die jeweils veröffentlichte Fassung maßgeblich.
            </p>
            <p>
              (3) Soweit zwischen Scholz Interim und einem Nutzer bereits ein gesondertes Vertragsverhältnis besteht, richten sich Änderungen der dafür geltenden Vertragsbedingungen ausschließlich nach den hierfür maßgeblichen gesetzlichen und vertraglichen Regelungen.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 28 Anwendbares Recht</h2>
            <p>
              (1) Für die Nutzung dieser Website und diese Allgemeinen Geschäfts- und Nutzungsbedingungen gilt das Recht der Bundesrepublik Deutschland.
            </p>
            <p>
              (2) Zwingende gesetzliche Vorschriften, insbesondere solche, die aufgrund internationaler oder europarechtlicher Regelungen zwingend Anwendung finden, bleiben hiervon unberührt.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 29 Vorrang individueller Vereinbarungen</h2>
            <p>
              Diese Allgemeinen Geschäfts- und Nutzungsbedingungen enthalten keine Regelungen über Vergütung, Honorare, Vermittlungsbedingungen, Erfolgsvergütungen, Laufzeiten konkreter Aufträge oder sonstige individuelle Bedingungen einer geschäftlichen Zusammenarbeit. Entsprechende Vereinbarungen werden – soweit erforderlich – ausschließlich im jeweiligen Einzelfall zwischen Scholz Interim und dem betreffenden Vertragspartner getroffen. Solche individuellen Vereinbarungen haben für den jeweils geregelten Gegenstand Vorrang vor diesen allgemeinen Bestimmungen.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mt-6 sm:mt-8 mb-3 sm:mb-4 text-foreground">§ 30 Schlussbestimmungen</h2>
            <p>
              (1) Soweit einzelne Regelungen dieser Allgemeinen Geschäfts- und Nutzungsbedingungen aufgrund zwingender gesetzlicher Vorschriften nicht oder nicht vollständig anwendbar sein sollten, bleiben die übrigen Bestimmungen und die gesetzlichen Rechte der Beteiligten hiervon unberührt.
            </p>
            <p>
              (2) An die Stelle einer unwirksamen oder nicht anwendbaren Regelung treten die gesetzlichen Vorschriften.
            </p>
            <p>
              (3) Aus der Tatsache, dass Scholz Interim im Einzelfall bestehende Rechte nicht oder nicht unmittelbar geltend macht, kann kein genereller Verzicht auf diese Rechte für die Zukunft hergeleitet werden.
            </p>
            <p>
              (4) Maßgeblich ist die jeweils auf der Website veröffentlichte Fassung dieser Allgemeinen Geschäfts- und Nutzungsbedingungen.
            </p>
          </section>

          <section>
            <p className="text-sm text-muted-foreground mt-8">
              Scholz & Scholz Recruitment UG (haftungsbeschränkt)<br />
              Römerstraße 6<br />
              21680 Stade
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Agb;
